import React, { Component } from 'react';
import { Form, Input, Modal } from 'antd';

const FormItem = Form.Item;

class Manage extends Component {
  handleOk = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.handleOk(values);
      }
    });
  };

  render() {
    const {
      form: { getFieldDecorator },
      visible,
      handleCancel,
    } = this.props;
    return (
      <Modal
        title="退回理由"
        visible={visible}
        onOk={this.handleOk}
        onCancel={() => handleCancel(false)}
      >
        <Form>
          <FormItem label="原因">
            {getFieldDecorator('refuse', {
              rules: [{ required: true, message: '请填写退回理由' }],
            })(<Input />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Manage);



// WEBPACK FOOTER //
// ./src/components/administrative/purchase/workflow/ModalReject.js